var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect } from "react";
import ReportValue from "../../../../../../shared-library/components/commonTableVal";
import { addCommas, roundUpToTwoDecimalPlaces, } from "@domains/utils/numberMethods";
import di from "../../di/serviceLocator";
import Spinner from "react-bootstrap/Spinner";
import { AUMInsuranceColumnsList, } from "@domains/salesFeatures/Clients/entities/IAUMInsurance";
import EdModal from "../../../../../../shared-library/components/edModal";
import GenericTable from "../../../../../../shared-library/components/GenericTable";
import { useSelector } from "react-redux";
import { getSortedData } from "@domains/utils/sort";
var AumData = function (props) {
    var _a, _b, _c, _d;
    var _e = __read(React.useState([false]), 2), openAcc = _e[0], setOpenAcc = _e[1];
    var _f = __read(React.useState([]), 2), aumData = _f[0], setAumData = _f[1];
    var _g = __read(React.useState(), 2), subInsuranceData = _g[0], setSubInsuranceData = _g[1];
    var _h = __read(React.useState(true), 2), loader = _h[0], setLoader = _h[1];
    // const [tableData, setTableData] = React.useState<IAUMSummaryDetailsEntity[]>(
    //   []
    // );
    var _j = __read(React.useState({
        key: "",
        dataType: "",
    }), 2), sortType = _j[0], setSortType = _j[1];
    var _k = __read(React.useState(false), 2), sortingType = _k[0], setSortingType = _k[1];
    var _l = __read(React.useState(false), 2), openPopup = _l[0], setOpenPopup = _l[1];
    var getAumSub = function (subDataHead) {
        setAumData(function (aumData) {
            if (aumData && aumData.length > 0) {
                aumData = aumData.map(function (record) {
                    if (record.productName === subDataHead) {
                        record.loader = true;
                        setLoader(true);
                        if ((props === null || props === void 0 ? void 0 : props.accountCode) && subDataHead) {
                            if (record.productName === "Insurance") {
                                di.clients
                                    .getAumInsuranceData({ accode: props === null || props === void 0 ? void 0 : props.accountCode })
                                    .then(function (resp) {
                                    if (resp &&
                                        resp.aumInsuranceList &&
                                        resp.aumInsuranceList.length > 0) {
                                        record.aumInsuranceData = resp.aumInsuranceList;
                                        record.loader = false;
                                        setLoader(false);
                                    }
                                    else {
                                        record.aumInsuranceData = [];
                                        record.loader = false;
                                        setLoader(false);
                                    }
                                })
                                    .catch(function (resp) {
                                    record.aumInsuranceData = [];
                                    record.loader = false;
                                });
                            }
                            else {
                                di.clients
                                    .getAUMSummaryDetails({
                                    AcCode: props === null || props === void 0 ? void 0 : props.accountCode,
                                    Flag: subDataHead,
                                })
                                    .then(function (resp) {
                                    if (resp && resp.length > 0) {
                                        record.summaryAumData = resp;
                                    }
                                    else {
                                        record.summaryAumData = [];
                                    }
                                    record.loader = false;
                                    setLoader(false);
                                })
                                    .catch(function (error) {
                                    record.summaryAumData = [];
                                    record.loader = false;
                                    setLoader(false);
                                });
                            }
                        }
                        else {
                            record.summaryAumData = [];
                            record.aumInsuranceData = [];
                            record.loader = false;
                        }
                    }
                    return record;
                });
            }
            return aumData;
        });
    };
    var aumDataForTotal = useSelector(function (state) { return state.Clients.AUMData.reducersData; });
    var applySorting = function (key, dataType, sortType, data) {
        setSortingType(sortType);
        setSortType({
            key: key,
            dataType: dataType,
        });
        var result = getSortedData(data, sortType, key, dataType);
        return result;
    };
    var applySortingAccordingKey = function (key, dataType, sortType, data, productName) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setAumData(function (aumData) {
                if (aumData && aumData.length > 0) {
                    aumData = aumData.map(function (record) {
                        if (record.productName === productName) {
                            record.summaryAumData = applySorting(key, dataType, sortType, data ? data : record.summaryAumData);
                        }
                        return record;
                    });
                }
                return aumData;
            });
            return [2 /*return*/];
        });
    }); };
    var AUMtableSublist = [
        {
            title: "Security",
            key: "Security",
            arrows: true,
            type: "string",
            applySorting: true,
        },
        {
            title: "Product Name",
            key: "ProductName",
        },
        {
            title: "TotalQty",
            key: "TotalQty",
        },
        {
            title: "AvgPrice(₹)",
            key: "AvgPrice",
        },
        {
            title: "Invested Amount(₹)",
            key: "InvestedAmount",
        },
        {
            title: "Current Price(₹)",
            key: "CurrentPrice",
        },
        {
            title: "Current Value(₹)",
            key: "CurrentValue",
        },
        {
            title: (React.createElement(React.Fragment, null,
                "Unrealized(\u20B9)",
                React.createElement("br", null),
                " Gain/Loss(%)")),
            key: "Unrealized",
        },
        {
            title: (React.createElement(React.Fragment, null,
                "Day's(\u20B9)",
                React.createElement("br", null),
                " Gain/Loss(%)")),
            key: "Days",
        },
    ];
    var transactionColumns = [
        {
            columnName: "Policy Id",
            key: "policyId",
        },
        {
            columnName: "Transaction Date",
            key: "transactionDate",
        },
        {
            columnName: "Transaction Id",
            key: "transactionId",
        },
        {
            columnName: "Transaction Type",
            key: "transactionType",
        },
        {
            columnName: "Amount",
            key: "amount",
        },
        {
            columnName: "Status",
            key: "status",
        },
    ];
    useEffect(function () {
        var _a;
        if (props.data && ((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.length) > 0)
            setAumData(props.data);
    }, [props === null || props === void 0 ? void 0 : props.data]);
    return (React.createElement(React.Fragment, null,
        aumData &&
            aumData.length > 0 &&
            aumData.map(function (aum, idx) {
                var _a, _b, _c;
                return (
                // <tr key={idx}>
                //   <td colSpan={30}>
                // <div
                //   className={`profile-test-block1 aum commonscroll-new ${
                //     openAcc[idx] ? "openAccmain" : ""
                //   }`}>
                // <table className="table common-table Aumdata-table">
                React.createElement("tbody", { 
                    // className={`profile-test-block1 aum commonscroll-new ${
                    //   openAcc[idx] ? "openAccmain" : ""
                    //   }`}\
                    className: openAcc[idx] ? "border-all" : "aum-body" },
                    React.createElement("tr", { className: "profile-main-tablebody-tr ".concat(openAcc[idx] ? "openAcc" : ""), onClick: function () {
                            if (aum.productName)
                                getAumSub(aum.productName);
                        } },
                        React.createElement("td", { className: "text" },
                            (aum === null || aum === void 0 ? void 0 : aum.productName) !== "Cash" ? (React.createElement("span", { className: "hand_cursor" },
                                React.createElement("i", { className: openAcc[idx]
                                        ? "edel-icon-arrow-up"
                                        : "edel-icon-arrow-down", onClick: function () {
                                        //   props.setSubDataHead(aum?.productName);
                                        var temp = __spreadArray([], __read(openAcc), false);
                                        temp[idx] = !temp[idx];
                                        setOpenAcc(temp);
                                    } }))) : (React.createElement("span", { className: "me-4 pe-2" })),
                            React.createElement("span", { className: "arrowicon-td" }, aum === null || aum === void 0 ? void 0 : aum.productName)),
                        React.createElement("td", { className: "roboto-num text-right" }, addCommas(aum === null || aum === void 0 ? void 0 : aum.investedValue)),
                        React.createElement("td", { className: "roboto-num text-right" }, addCommas(aum === null || aum === void 0 ? void 0 : aum.marketValue)),
                        React.createElement("td", { className: "roboto-num text-right" }, aum === null || aum === void 0 ? void 0 : aum.dreturn),
                        React.createElement("td", { className: "roboto-num text-right" }, addCommas(aum === null || aum === void 0 ? void 0 : aum.totalHoldingPercent))),
                    openAcc[idx] && (React.createElement("tr", null,
                        React.createElement("td", { colSpan: 5, className: "p-0" },
                            React.createElement("div", { className: "commonscroll-new inside-scroll table-responsive profile-accordion-table-block Aum-data-section" },
                                React.createElement("table", { className: "w-100 inner-table" },
                                    React.createElement("thead", { className: "profile-main-tablebody-sub-tr-heading sticky-top bg_white" },
                                        React.createElement("tr", null,
                                            aum.productName !== "Insurance" &&
                                                AUMtableSublist.map(function (items, idx) {
                                                    return (React.createElement("th", { className: "DMSansMedium_12_500 txt_primaryGrey ", key: idx, onClick: function () {
                                                            return (items === null || items === void 0 ? void 0 : items.applySorting)
                                                                ? applySortingAccordingKey(items.key, items.type, !sortingType, aum.summaryAumData, aum.productName)
                                                                : null;
                                                        } }, (items === null || items === void 0 ? void 0 : items.arrows) ? (React.createElement("div", { className: "title" },
                                                        items.title,
                                                        React.createElement("div", { className: "arrows" },
                                                            React.createElement("i", { className: "edel-icon-caret-up" }),
                                                            React.createElement("i", { className: "edel-icon-caret-down" })))) : (items.title)));
                                                }),
                                            aum.productName === "Insurance" &&
                                                AUMInsuranceColumnsList.map(function (record, subId) {
                                                    return (React.createElement("th", { className: "DMSansMedium_12_500 txt_primaryGrey ", key: subId }, record.title));
                                                }))),
                                    React.createElement("tbody", null,
                                        (aum === null || aum === void 0 ? void 0 : aum.loader) && (React.createElement("tr", null,
                                            React.createElement("td", { colSpan: 11 },
                                                React.createElement("div", { className: "spinner-box d-flex justify-content-center" },
                                                    React.createElement(Spinner, { animation: "border", variant: "primary" }))))),
                                        !(aum === null || aum === void 0 ? void 0 : aum.loader) &&
                                            aum.summaryAumData &&
                                            ((_a = aum.summaryAumData) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                                            ((_b = aum.summaryAumData) === null || _b === void 0 ? void 0 : _b.map(function (subList, id) {
                                                return (React.createElement("tr", { className: "profile-main-tablebody-sub-tr-tbody" },
                                                    React.createElement("td", { className: "DMSan_14_700" }, subList === null || subList === void 0 ? void 0 : subList.Security),
                                                    React.createElement("td", { className: "RobotoM_14_500" }, subList === null || subList === void 0 ? void 0 : subList.EdelweissProduct),
                                                    React.createElement("td", { className: "RobotoM_14_500" },
                                                        React.createElement(ReportValue, { val: subList === null || subList === void 0 ? void 0 : subList.TotalQty, stream: false, onlyval: false })),
                                                    React.createElement("td", { className: "RobotoM_14_500" },
                                                        React.createElement(ReportValue, { val: subList === null || subList === void 0 ? void 0 : subList.AveragePrice, stream: false, onlyval: false })),
                                                    React.createElement("td", { className: "RobotoM_14_500" },
                                                        React.createElement(ReportValue, { val: subList === null || subList === void 0 ? void 0 : subList.InvestedAmount, stream: false, onlyval: false })),
                                                    React.createElement("td", { className: "RobotoM_14_500" },
                                                        React.createElement(ReportValue, { val: subList === null || subList === void 0 ? void 0 : subList.CurrentPrice, stream: false, onlyval: false })),
                                                    React.createElement("td", { className: "RobotoM_14_500" },
                                                        React.createElement(ReportValue, { val: subList === null || subList === void 0 ? void 0 : subList.CurrentValue, stream: false, onlyval: false })),
                                                    React.createElement("td", { className: "RobotoM_14_500" },
                                                        React.createElement(ReportValue, { val: subList === null || subList === void 0 ? void 0 : subList.UnrealisedPLAmount, stream: false, onlyval: false }),
                                                        React.createElement("div", null,
                                                            React.createElement(ReportValue, { val: subList === null || subList === void 0 ? void 0 : subList.UnrealisedPLPercentage, stream: true, onlyval: false }))),
                                                    React.createElement("td", { className: "RobotoM_14_500" },
                                                        React.createElement(ReportValue, { val: subList === null || subList === void 0 ? void 0 : subList.DaysGainLossAmount, stream: false, onlyval: false }),
                                                        React.createElement("div", null,
                                                            React.createElement(ReportValue, { val: subList === null || subList === void 0 ? void 0 : subList.DaysGainLossPercentage, stream: true, onlyval: false })))));
                                            })),
                                        !aum.loader &&
                                            aum.aumInsuranceData &&
                                            ((_c = aum.aumInsuranceData) === null || _c === void 0 ? void 0 : _c.length) > 0 &&
                                            aum.aumInsuranceData.map(function (subList, id) {
                                                return (React.createElement("tr", { className: "profile-main-tablebody-sub-tr-tbody", key: id },
                                                    React.createElement("td", { className: "DMSan_14_700 text-decoration-underline hand_cursor txt-blue-one", onClick: function () {
                                                            setOpenPopup(true);
                                                            setSubInsuranceData(subList.transactionDetails);
                                                        } }, subList === null || subList === void 0 ? void 0 : subList.policyId),
                                                    React.createElement("td", { className: "RobotoM_14_500" }, subList === null || subList === void 0 ? void 0 : subList.policyName),
                                                    React.createElement("td", { className: "RobotoM_14_500" }, subList === null || subList === void 0 ? void 0 : subList.term),
                                                    React.createElement("td", { className: "RobotoM_14_500" }, subList === null || subList === void 0 ? void 0 : subList.policyDate),
                                                    React.createElement("td", { className: "RobotoM_14_500" }, subList === null || subList === void 0 ? void 0 : subList.term),
                                                    React.createElement("td", { className: "RobotoM_14_500" }, subList === null || subList === void 0 ? void 0 : subList.schedule),
                                                    React.createElement("td", { className: "RobotoM_14_500" },
                                                        React.createElement(ReportValue, { val: subList === null || subList === void 0 ? void 0 : subList.premiumAnnulaized, stream: false, onlyval: false })),
                                                    React.createElement("td", { className: "RobotoM_14_500" },
                                                        React.createElement(ReportValue, { val: subList === null || subList === void 0 ? void 0 : subList.amountInvested, stream: false, onlyval: false })),
                                                    React.createElement("td", { className: "RobotoM_14_500" },
                                                        React.createElement(ReportValue, { val: subList === null || subList === void 0 ? void 0 : subList.currentValuation, stream: false, onlyval: false })),
                                                    React.createElement("td", { className: "RobotoM_14_500" }, subList === null || subList === void 0 ? void 0 : subList.nextdueDate),
                                                    React.createElement("td", { className: "RobotoM_14_500" }, subList === null || subList === void 0 ? void 0 : subList.paymentMode),
                                                    React.createElement("td", { className: "RobotoM_14_500" }, subList === null || subList === void 0 ? void 0 : subList.status)));
                                            }))))))))
                // </table>
                //</div>
                //   </td>
                // </tr>
                );
            }),
        React.createElement("tfoot", { className: "profile-main-tablebody-tr bg-TotalTr bg_blackOne1" },
            React.createElement("td", { className: "text" }, "Total"),
            React.createElement("td", { className: "roboto-num text-right" }, addCommas((_a = props === null || props === void 0 ? void 0 : props.mainAumData) === null || _a === void 0 ? void 0 : _a.totalInvestedValue)),
            React.createElement("td", { className: "roboto-num text-right" }, addCommas((_b = props === null || props === void 0 ? void 0 : props.mainAumData) === null || _b === void 0 ? void 0 : _b.totalMarketValue)),
            React.createElement("td", { className: "roboto-num text-right" }, (props === null || props === void 0 ? void 0 : props.data) &&
                roundUpToTwoDecimalPlaces((_c = props === null || props === void 0 ? void 0 : props.mainAumData) === null || _c === void 0 ? void 0 : _c.totalDReturn)),
            React.createElement("td", { className: "roboto-num text-right" }, addCommas((_d = props === null || props === void 0 ? void 0 : props.mainAumData) === null || _d === void 0 ? void 0 : _d.totalPercentage))),
        React.createElement(EdModal, { show: openPopup, setShow: setOpenPopup, showFooter: false, children: React.createElement(GenericTable, { tableClassName: "transaction-table service", data: subInsuranceData, columns: transactionColumns, loader: loader, message: {
                    msg: "No Data Found",
                    show: subInsuranceData && (subInsuranceData === null || subInsuranceData === void 0 ? void 0 : subInsuranceData.length) === 0,
                    icon: "",
                } }), modalTitle: "sales-client commonmodal mf-transaction" })));
};
export default AumData;
